import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=32661a5d"
import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1_postcss@8_cee907f41370107bcc48efa63f51a283/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports